<script lang="ts">
import Vue from 'vue'
import {createOrganizations, getRegions} from "@/api/organizations/organizations"
import BaseModal from "@/components/ui/BaseModal.vue";
import modalMixin from "@/views/organizations/mixins/modalMixin";

export default Vue.extend({
    name: "AddBranchModal",
    components: {BaseModal},
    mixins: [modalMixin],
    data() {
        return {
            name: null,
            regionId: null,
            regions: [],
            loadRegions: false,
        }
    },
    methods: {
        save() {
            const form = {
                name: this.name,
                parent_id: this.regionId,
                type: 'branch'
            }

            createOrganizations(form).then(() => {
                this.visible = false
                this.name = null
                this.regionId = null

                this.$emit('saved')
            })
        },
        getRegions() {
            getRegions({organizationId: this.$store.getters.USER.organizationId}).then(response => {
                this.regions = response.data;
                this.loadRegions = false;
            })
        }
    }
})
</script>

<template>
    <div>
        <BaseModal v-model="visible">
            <div class="title">Додати відділення</div>
            <div class="row mt-8">
                <div class="col-12">
                    <label>Дирекція</label>
                    <el-select v-model="regionId"
                               :loading="loadRegions"
                               :popper-append-to-body="false"
                               placeholder="Дирекція"
                               @focus="getRegions"
                    >
                        <el-option v-for="item in regions"
                                   :key="item.id"
                                   :label="item.name"
                                   :value="item.id">
                        </el-option>
                    </el-select>
                </div>
            </div>
            <div class="row mt-8">
                <div class="col-12">
                    <label>Назва</label>
                    <input type="text" class="form-control" v-model="name">
                </div>
            </div>
            <div class="row mt-4">
                <div class="col">
                    <button type="button" class="btn btn-primary w-100" @click="save">Додати</button>
                </div>
            </div>
        </BaseModal>
    </div>
</template>

<style scoped lang="scss">
.title {
    font-family: Geist, serif;
    font-style: normal;
    font-weight: 500;
    font-size: 24px;
    line-height: 28px;
    /* identical to box height, or 117% */
    text-align: center;

    color: #09090B;

    /* Inside auto layout */
    flex: none;
    order: 0;
    align-self: stretch;
    flex-grow: 0;
    margin-bottom: 21px;
}
.el-select {
    display: unset;
    position: unset;
    .el-input.is-focus {
        border-color: #FFAD3D;
    }
    .el-input__inner:focus {
        border-color: #FFAD3D;
    }
}
</style>
